import Vue from 'vue';
import App from './App.vue';
import { sync } from 'vuex-router-sync';
import router from './router';
import store from './store';
import axios from 'axios';
import VueCookie from 'vue-cookie';
import bulma from 'bulma';

import 'vue-multiselect/dist/vue-multiselect.min.css';

Vue.config.productionTip = false;

sync(store, router);

Vue.use(VueCookie);

new Vue({
  router,
  store,
  render: h => h(App),
  components: { axios, bulma }
}).$mount('#app');
